import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import AdminPanel from './components/AdminPanel';
import AdminUsuarioDetalle from './components/AdminUsuarioDetalle';
import Dashboard from './components/Dashboard';
import Evaluacion from './components/Evaluacion';
import HistorialEvaluaciones from './components/HistorialEvaluaciones';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import EnConstruccion from './components/EnConstruccion';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/en-construccion" element={<EnConstruccion />} />
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/evaluacion/:usuarioId" element={<PrivateRoute><Evaluacion /></PrivateRoute>} />
            <Route path="/historial" element={<PrivateRoute><HistorialEvaluaciones /></PrivateRoute>} />
            <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
            <Route path="/admin/usuarios/:id" element={<AdminRoute><AdminUsuarioDetalle /></AdminRoute>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

